export const getPaymentTypes = state => state.paymentType.data.paymentType.length ? state.paymentType.data.paymentType : [ { value: '-1', label: 'Cargando...' } ];
export const getSessionRol = state => state.paymentType.errorRol;
export const getIsFetching = state => state.paymentType.isFetching;
export const getErrorMessage = state => state.paymentType.errorMessage;
